import { client } from "@/http/client"

export const getVersion = (): Promise<string> =>
  client.get("/rnum/v")